/* @flow */
/*jshint esversion: 6 */

import React, { Component } from "react";
import "../../App.css";
import { Icon, Select, Tooltip, Popconfirm, Radio, Popover, Button, Form, Row, Col, Input, message } from "antd";

import TableIDs from "../../data/TableIDs";
import PageToolbar from "../../components/PageToolbar";
import { fixCurrentPage } from "../../utils/utils";
import ModalPurchaseAdvanceSearch from "../../components/ModalPurchaseAdvanceSearch";
import ModalEditPurchaseDocument from "../../components/ModalEditPurchaseDocument";
import ResponsiveTable from "../../components/ResponsiveTable";
import LangContext from "../../contextProvider/LangContext";
import GenericModal from "../../components/GenericModal";
import DateTimePicker from "../../components/DateTimePicker";
import GenericSelector from "../../components/GenericSelector";
import GenericSelectorSuppliers from "../../components/GenericSelectorSuppliers";
import ReportTypeButton from "../../components/ReportTypeButton";
import GenericSelectorItemTags from "../../components/GenericSelectorItemTags";
import GenericSelectorPosStorages from "../../components/GenericSelectorPosStorages";
import { Job, User, OutputType, ProcessType } from '../../JmReact';
import moment from "moment";
import ReportShowButton from "../../components/ReportShowButton";
import GenericTable from "../../components/GenericTable";
import CopyDocumentReport from "../reports/PaymentsSearchReport";
import TableLineIcons from "../../components/TableLineIcons";



const { Option, OptGroup } = Select;

const topHeight = 340; // px
const rowHeight = 30;  // px

type Props = {
    user: any,
    ui: any,
    uiActions: any,
    dataActions: any,
    data: Object
};
type State = {
    defaultItemCode: string,
    itemCodeSelectionVisible: boolean
};

class PurchaseDocumentsTable extends Component<Props, State> {
    id: any;
    api: any;
    actionButtons: any;

    constructor(props: Props) {
        super(props);
        this.id = "PURCHES_DOCS_MAIN";
        this.concat_id = "DOCUMENTS_CONCAT";
        this.lines_id = "PURCHASE_DOC_LINES";

        this.reportRequestDefaults = {
            _words: '',
            _isAsc: 0,
            _sort_by: 'col_3',
            _FromDate: moment().add(-1, "month").format("YYYY-MM-DD"),
            _ToDate: moment().format("YYYY-MM-DD"),
            _PosList: '',
            _StorageList: '',
            _SupplierList: '',
            _itemTagList: '',
            _typeID: '',
            reportName: "reports/PurchaseReport.pdf",
        }

        this.state = {
            defaultItemCode: "",
            itemCodeSelectionVisible: false,
            modalReport: false,
            reportRequest: this.reportRequestDefaults,
            modalSumAndDiscountDoc: null,
            modalConcatDocs: null,
            modalSummary: null,
            modalAddConcatDocs: false,
            modalEditConcatRemark: null,
        };

        // calc page height
        this.state.height = window.innerHeight;
        this.doOnResize = null;

        if (props.data[this.id] === undefined) {
            props.data[this.id] = { ...props.data.genericData };
        }

        if (props.data[this.concat_id] === undefined) {
            props.data[this.concat_id] = { ...props.data.genericData };
        }

        if (props.data[this.lines_id] === undefined) {
            props.data[this.lines_id] = { ...props.data.genericData };
        }

        if (props.data[TableIDs.genericSelectorPos] === undefined) {
            props.data[TableIDs.genericSelectorPos] = { ...props.data.genericSelector };
        }

        if (props.data[TableIDs.genericSelectorStorages] === undefined) {
            props.data[TableIDs.genericSelectorStorages] = { ...props.data.genericSelector };
        }


        this.api = {
            get: "get_document_purchase_list_table",
            delete: "delete_supplier",

            get_filter: "get_filter_favorite_data",

            get_concat: "get_documents_concat",
            add_concat: "add_document_concat",
            edit_concat: "edit_documents_concat",
            delete_concat: "delete_documents_concat",

            get_lines: "get_documentLines_purchase_list_table",

        }

    }

    static contextType = LangContext;

    getText = (id) => this.context.get(id) || '[' + id + ']';

    componentDidMount() {

        this.props.dataActions.getItemCodes(this.props.user.companyCode, this.props.user.token);
        this.initFilters();
        // this.props.dataActions.genericSelectorRefreshDataset(
        //     TableIDs.genericSelectorPrices, this.props.user.companyCode, this.props.user.token, this.api.selector);
        //this.refreshData();
        this.props.dataActions.genericSelectorRefreshDataset(
            TableIDs.genericSelectorPos, this.props.user.companyCode, this.props.user.token, "list_pos");

        window.addEventListener("resize", () => {
            clearTimeout(this.doOnResize);
            this.doOnResize = setTimeout(this.handleWindowSizeChange, 100)
        });

        // setTimeout(() => {
        //     if (!this.props.ui.favoriteParams) {
        //         this.props.uiActions.showModal(TableIDs.modalSearchPuchaseTable)
        //     }
        // }, 200);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.handleWindowSizeChange);
    }

    handleWindowSizeChange = () => {
        if (!(/Android/i.test(navigator.userAgent)))
            this.setState({ height: window.innerHeight }, this.refreshData);
        //console.log("re render", window.innerHeight, " state: ", this.state.height)
    };

    componentDidUpdate(prevProps) {
        document.title = "Cash On Tab - " + this.getText(10183);
        if (
            this.props.data[TableIDs.genericSelectorPos].dataset !== prevProps.data[TableIDs.genericSelectorPos].dataset ||
            (this.props.data[TableIDs.genericSelectorPos].dataset[0] && !this.state.loading)
        ) this.setState({ loading: true }, this.initFilters)

        if (prevProps.ui.favoriteParams !== this.props.ui.favoriteParams) {
            this.setState({ modalReport: true, reportRequest: { ...this.state.reportRequest, ...this.props.data[this.id].filters, ...this.props.ui.favoriteParams } })
        }

    }

    initFilters = () => {
        let fullPosList = this.props.data[TableIDs.genericSelectorPos].dataset.map((obj) => obj['code']).join(',');
        let numOfRowsByHeight = parseInt((this.state.height - topHeight > rowHeight)
            ? (this.state.height - topHeight) / rowHeight
            : 1);

        let request = {
            _id: 0, // for testing. TODO: "read" from selector
            // ui
            page: 1,
            recordsPerPage: numOfRowsByHeight,
            sortType: 0,
            sortColumn: 0,
            // api
            _words: '',
            _page_num: 1,
            _rows_num: numOfRowsByHeight,
            _isAsc: 0,
            _sort_by: 'col_3',

            _FromDate: moment().add(-1, "month").format("YYYY-MM-DD"),
            _ToDate: moment().format("YYYY-MM-DD"),
            _PosList: fullPosList,
            _StorageList: "",
            _SupplierList: "",
            _typeID: "4",
            _isHandled: "0",
        };

        this.sendAPI(this.api.get_filter, "_url\r" + window.location.pathname, (ob) => {
            if (ob.data) {
                ob.data.split('\r').forEach(x => {
                    let y = x.split('\f');
                    request = { ...request, [y[0]]: y[1] === 'null' || y[1] === 'undefined' ? null : y[1] }
                })
            }

            this.props.dataActions.genericDataSetFilter(
                this.id, this.props.user.companyCode, this.props.user.token, request, this.api.get);
        }, e => { console.error(e) })

    }

    refreshData = () => {
        this.props.dataActions.genericDataGetRequested(
            this.id, this.props.user.companyCode, this.props.user.token, this.api.get);
        this.props.dataActions.genericSelectorRefreshDataset(
            TableIDs.genericSelectorPrices, this.props.user.companyCode, this.props.user.token, this.api.selector);
    }

    handleTableChange = (pagination: Object, filters: Object, sorter: Object) => {
        let col = 11;
        // fall through
        switch (sorter.field) {
            case "key": col--; // 0
            case "mNumber": col--;
            case "mPOSID": col--;
            case "mTimestamp": col--;
            case "mDocumentRef2": col--;
            case "mRemarksDocDate": col--;
            case "mSupplierID": col--;
            case "mSupplierName": col--;
            case "mTotalWithTax": col--;
            case "mEmployeeID": col--;
            case "mTypeName": col--;
            case "mStorageID": break; // 11
            default:
                col = 0;
        }
        console.log("Suppliers - handle table change: ", pagination, filters, sorter);

        let request = {
            // just of ui-pagination update
            page: pagination.current,
            recordsPerPage: pagination.pageSize,
            sortType: sorter.order === undefined || sorter.order === "ascend" ? 1 : 0,
            sortColumn: col,
            //
            _page_num: pagination.current,
            _rows_num: pagination.pageSize,
            _isAsc: sorter.order === undefined || sorter.order === "ascend" ? 1 : 0,
            _sort_by: 'col_' + col,
            //_words: '',
        };

        this.props.dataActions.genericDataSetFilter(
            this.id, this.props.user.companyCode, this.props.user.token, request, this.api.get)
    }

    handleCreateNew = () => {
        this.props.dataActions.genericDataStartInlineCreate(this.id);
    }
    handleCreateFormCancel = () => {
        this.props.dataActions.genericDataCancelNew(this.id);
    }
    handleShowFilters = () => {
        this.props.dataActions.genericDataShowFilters(this.id);
    }
    handleHideFilters = () => {
        this.props.dataActions.genericDataHideFilters(this.id);
    }
    handleClearFilters = () => {
        this.props.dataActions.genericDataClearFilters(
            this.id, this.props.user.companyCode, this.props.user.token, this.props.data.genericData.pagination.defaultPageSize);
    }

    handleChangeCheckBox = (e: any, val: any, dataIndex: string, record: any) => {
        console.log("checkbox change: ", e.target.checked, { [dataIndex]: (e.target.checked) ? 1 : 0 });
        this.props.dataActions.genericDataSetEdit(
            this.id, { [dataIndex]: (e.target.checked) ? 1 : 0 }
        )
    }

    checkIfChecked = (col: any, text: any, record: any) => {
        let checkedVal = (this.props.data[this.id].editing === record.key)
            ? this.props.data[this.id].editedRecord[col] : text;
        return (checkedVal == 1 || checkedVal === '1') ? true : false;
    }

    generateReport = () => {
        const { _FromDate, _ToDate, _PosList, _StorageList, _SupplierList, _itemTagList, _isAsc, _sort_by, _words, _typeID, reportName } = this.state.reportRequest;

        let params = {
            _FromDate,
            _ToDate,
            _PosList,
            _StorageList,
            _SupplierList,
            _itemTagList,
            _isAsc,
            _sort_by,
            _words: encodeURIComponent(_words),
            _typeID,
            reportName,
            REPORT_LOCALE: this.getText(101),
        }
        this.props.ActionQueue.addToQueue({
            action: this.props.dataActions.generateReport,
            args: [this.props.user.companyCode, this.props.user.token, params]
        });

    }

    getModalReportField = (field) => {
        const value = this.state.reportRequest[field]
        const onChange = (e) => { this.setState({ reportRequest: { ...this.state.reportRequest, [field]: e } }) }
        const minDate = field === '_ToDate' ? this.state.reportRequest._FromDate : null;
        const maxDate = field === '_FromDate' ? this.state.reportRequest._ToDate : null;
        switch (field) {
            case '_FromDate': case '_ToDate':
                return (<DateTimePicker format="DD/MM/YYYY" {...{ value, onChange, minDate, maxDate }} />)
            case '_PosList':
                return (<GenericSelectorPosStorages
                    {...this.props}
                    value={value ? value.split(",") : []}
                    onChange={e => { onChange(e ? e.join(",") : "") }}
                    // id={TableIDs.genericSelectorPos}
                    multi
                />)
            case '_StorageList':
                return (<GenericSelector
                    {...this.props}
                    id={TableIDs.genericSelectorStorages}
                    api={"get_storage_list"}
                    value={value ? value.split(",") : []}
                    onChange={e => { onChange(e ? e.join(",") : "") }}
                    multi
                />)
            case '_SupplierList':
                return (<GenericSelectorSuppliers
                    {...this.props}
                    value={value ? value.split(",") : []}
                    onChange={e => { onChange(e ? e.join(",") : "") }}
                    multi
                />)
            case '_itemTagList':
                return (<GenericSelectorItemTags
                    {...this.props}
                    value={value ? value.split(",") : []}
                    onChange={e => { onChange(e ? e.join(",") : "") }}
                    multi
                />)
            case '_words':
                return (<Input value={value} onChange={e => { onChange(e.target.value) }} />)
            case '_typeID':
                return (<Radio.Group value={value} onChange={e => { onChange(e.target.value) }} >
                    <Radio value={''}>{this.getText(16233)}</Radio>
                    <Radio value={'4'}>{this.getText(16234)}</Radio>
                    <Radio value={'18'}>{this.getText(16235)}</Radio>
                </Radio.Group>);
            case 'reportName':
                return (<Select style={{ width: '100%' }} {...{ value, onChange }}>
                    <Select.Option value={"reports/PurchaseReport.pdf"}>{this.getText(16238)}</Select.Option>
                    <Select.Option value={"reports/PurchaseReportCentralSupplier.pdf"}>{this.getText(16239)}</Select.Option>
                    <Select.Option value={"reports/PurchaseReportCentralDoc.pdf"}>{this.getText(16240)}</Select.Option>
                    <Select.Option value={"reports/PurchaseReportCentralItems.pdf"}>{this.getText(17922)}</Select.Option>
                    <Select.Option value={"reports/PurchaseReportMatrixItemsByStorage.pdf"}>{this.getText(17923) + " " + this.getText(17924)}</Select.Option>
                    <Select.Option value={"reports/PurchaseReportMatrixItemsByColor.pdf"}>{this.getText(17923) + " " + this.getText(17925)}</Select.Option>
                </Select>)
        }
    }

    sendAPI = (script, data, sCall) => {
        let user = new User(this.props.user.token, this.props.user.companyCode);
        let job = new Job(user, script, OutputType.OUTPUT_TYPE_DATA, ProcessType.PROCESS_TYPE_SYNC);
        job.setInput(data);
        job.send("/cgi-bin/CashOnTab", sCall, (e) => { console.error(e) });
    };

    refreshConcatDocsData = () => {
        this.props.dataActions.genericDataGetRequested(
            this.concat_id, this.props.user.companyCode, this.props.user.token, this.api.get_concat);
    }

    concatDocsActions = (t, record) => {
        return (<>
            <ReportShowButton
                {...this.props}
                iconButton
                validSubmit
                params={{
                    DocumentNumber: record['dNum'],
                    DocumentTypeID: record['dTypeId'],
                    DocumentPOSID: record['dPos'],
                    userID: this.props.user.userId,
                    userName: encodeURIComponent(this.props.user.displayName),
                    docIsWithSigns: 0,
                    reportName: "reports/DocumentCopy.pdf"
                }} />
            <TableLineIcons
                genericIcons={[
                    {
                        type: "file-text",
                        onClick: () => { this.setState({ modalEditConcatRemark: record }) },
                        tooltip: this.getText(21877),
                        color: record.cRemark ? "red" : null
                    }, {
                        type: "delete",
                        onClick: () => {
                            this.props.dataActions.genericDataDeleteRow(
                                this.concat_id, record.key, this.props.user.companyCode, this.props.user.token,
                                this.api.delete_concat, this.api.get_concat)
                        },
                        popconfirm: { title: this.getText(21878), okText: this.getText(21879), cancelText: this.getText(21880) },
                        tooltip: this.getText(21884),
                    }
                ]} />
        </>)
    }

    addConcatDoc = (record) => {
        const { DocumentNumber, DocumentTypeId, DocumentPOSID } = record
        const { mNumber, mTypeID, mPOSID } = this.state.modalConcatDocs ?? {}
        if (DocumentNumber == mNumber && DocumentTypeId == mTypeID && DocumentPOSID == mPOSID) {
            message.error(this.getText(21843))
        } else if (this.props.data[this.concat_id].data.find(f => {
            const [cID, dNum, dTypeId, dPos] = f.split("\f")
            return DocumentNumber == dNum && DocumentTypeId == dTypeId && DocumentPOSID == dPos
        })) {
            message.error(this.getText(21844))
        } else {
            this.sendAPI(this.api.add_concat, {
                dNum: mNumber,
                dType: mTypeID,
                dPos: mPOSID,
                dNextNum: DocumentNumber,
                dNextType: DocumentTypeId,
                dNextPos: DocumentPOSID
            }, () => {
                this.setState({ modalAddConcatDocs: false }, this.refreshConcatDocsData)
            })
        }
    }

    apiSumAndDiscount = (record, next) => {
        let dataSend = "_num\f_type\f_pos\r"
            + record.mNumber + "\f"
            + record.mTypeID + "\f"
            + record.mPOSID
        this.sendAPI("get_sum_and_discount_doc", dataSend, (ob) => {
            const [dSum, dDiscount, dQty, dDiscountItem] = ob.data ? ob.data.split("\f") : [0, 0]
            let dPercent = new Intl.NumberFormat('en-US', {
                style: 'percent',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(parseFloat(dSum) && parseFloat(dDiscount) ? dDiscount / dSum : 0);
            next({ dSum, dDiscount, dPercent, dQty, dDiscountItem: dDiscountItem ? dDiscountItem : this.getText(21808) })
        })
    }

    apiLines = ({ mNumber, mTypeID, mPOSID }) => {
        let request = {
            _id: 0, _page_num: 1, _rows_num: 99999, _isAsc: 1, _sort_by: 'col_1', _words: '',
            mNumber, mDocType: mTypeID, mPOSID
        };
        this.props.dataActions.genericDataSetFilter(
            this.lines_id, this.props.user.companyCode, this.props.user.token, request, this.api.get_lines)
    }

    getConcatTable = (filters, pagination) => {
        let columns = [
            { title: this.getText(21837), key: "dDatetime", dataIndex: "dDatetime", width: "20%", render: t => moment(t).format("HH:mm DD/MM/YYYY") },
            { title: this.getText(21836), key: "dTypeName", dataIndex: "dTypeName", width: "20%", render: t => t },
            { title: this.getText(21835), key: "dNum", dataIndex: "dNum", width: "20%", render: t => t },
            { title: this.getText(21838), key: "dSum", dataIndex: "dSum", width: "20%", render: t => t },
            { title: this.getText(21839), width: "20%", render: this.concatDocsActions },
        ]
        if (!pagination) columns = columns.slice(0, -1).map(x => { return { ...x, width: "25%" } })

        return (<GenericTable
            {...this.props}
            tableOnly
            id={this.concat_id}
            getApi={this.api.get_concat}
            {...{ filters, pagination, columns }}
        />)
    }

    isHandledBtn = (record, fontSize, next) => {
        return (<Tooltip title={this.getText(record.mIsHandled == '1' ? 19414 : record.mIsHandled == '0' ? 19415 :/*     דני ביקש לשנות 2026-06-24   21941*/  19414)}>
            <Icon
                style={{ fontSize, color: record.mIsHandled == '1' ? "green" : record.mIsHandled == '0' ? "red" :/* דני ביקש לשנות 2026-06-24   "black" */ "green" }}
                className={"clickable margin-4"}
                type={"alert" /*record.mIsHandled == '1' ? "lock" : "unlock"*/}
                onClick={() => {
                    let newIsHandled = record.mIsHandled == '1' ? /* דני ביקש לשנות 2026-06-24   '' */ '0' : record.mIsHandled == '0' ? '1' : '0';
                    let dataSend = "_num\f_type\f_pos\f_isHandled\r"
                        + record.mNumber + "\f"
                        + record.mTypeID + "\f"
                        + record.mPOSID + "\f"
                        + newIsHandled
                    this.sendAPI("set_handled_doc", dataSend, () => {
                        //בוטל בהוראת דני 2026-06-17 // this.refreshData() 
                        this.props.dataActions.setJson(this.id, {
                            data: this.props.data[this.id].data.map((x, i) => {
                                if (i != record.index) return x;
                                let y = x.split("\f");
                                y[12] = newIsHandled;
                                return y.join("\f")
                            })
                        })
                        if (next) next()
                    })
                }} />
        </Tooltip>)
    }

    render() {

        const divStyle = {
            align: "center",
            dir: "rtl", // dir: 'ltr'
            padding: "2% 2% 2% 2%",
        };

        const dataSource = this.props.data[this.id].data.map((x, index) => {
            let y = x.split("\f");
            return ({
                key: y[0],
                mNumber: y[0],
                mPOSID: y[1],
                mTimestamp: y[2],
                mRemarksDocNum: y[3],
                mRemarksDocDate: y[4],
                mSupplierID: y[5],
                mSupplierName: y[6],
                mTotalWithTax: y[7],
                mEmployeeID: y[8],
                mTypeID: y[9],
                mTypeName: y[10],
                mDocumentRef2: y[11],
                mIsHandled: y[12],
                mStorageID: y[13],
                mStorageName: y[14],
                mEmployeeName: y[15],
                mPOSName: y[16],
                mTotalNoTax: y[17],
                mTotalTax: y[18],
                mSupplierEmail: y[19],
                index: index
            })
        });


        // let request = {
        //     // ui-pagination 
        //     page: 1,
        //     sortType: 0,
        //     // api
        //     _page_num: 1,
        //     _isAsc: 0,
        //     _sort_by: 'col_3',

        //     _FromDate: moment().add(-1, "month").format("YYYY-MM-DD"),
        //     _ToDate: moment().format("YYYY-MM-DD"),
        //     _PosList: '',
        //     _SupplierList: '',
        //     _typeID: '4',
        //     _isHandled: '0',
        // };

        const formatter = new Intl.NumberFormat('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });

        let columns = [
            {
                title: this.getText(11825),
                dataIndex: "mNumber",
                key: "mNumber",
                sorter: true,
                width: '8%',
                render: (text, record) => text,
            }, {
                title: this.getText(16229),
                dataIndex: "mTypeName",
                key: "mTypeName",
                sorter: true,
                width: '9%',
                render: (text, record) => text
            }, {
                title: this.getText(11826),
                dataIndex: "mPOSID",
                key: "mPOSID",
                width: '6%',
                sorter: true,
                render: (text, record) => text,
            }, {
                title: this.getText(11827),
                dataIndex: "mTimestamp",
                key: "mTimestamp",
                width: '12%',
                sorter: true,
                render: (text, record) => moment(text).format("HH:mm DD-MM-YYYY"),
            }, {
                title: this.getText(21796),
                dataIndex: "mStorageID",
                key: "mStorageID",
                width: '9%',
                sorter: true,
                render: (text, record) => `${text} - ${record.mStorageName}`,
            }, {
                title: this.getText(11828),
                dataIndex: "mDocumentRef2",
                key: "mDocumentRef2",
                width: '7%',
                sorter: true,
                render: (text, record) => text,
            }, {
                title: this.getText(11829),
                dataIndex: "mRemarksDocDate",
                key: "mRemarksDocDate",
                width: '9%',
                sorter: true,
                render: (text, record) => moment(text).format("DD-MM-YYYY"),
            }, {
                title: this.getText(11830),
                dataIndex: "mSupplierID",
                key: "mSupplierID",
                width: '7%',
                sorter: true,
                render: (text, record) => text,
            }, {
                title: this.getText(11831),
                dataIndex: "mSupplierName",
                key: "mSupplierName",
                width: '9%',
                sorter: true,
                render: (text, record) => text,
            }, {
                title: this.getText(11832),
                dataIndex: "mTotalWithTax",
                key: "mTotalWithTax",
                width: '6%',
                sorter: true,
                render: (text, record) => (<div style={{ textAlign: "right" }}>{record.mTypeID == '18' ? '-' : ''}{parseFloat(text) ? formatter.format(text) : "0.00"}</div>),
            }, {
                title: this.getText(11833),
                dataIndex: "mEmployeeID",
                key: "mEmployeeID",
                width: '8%',
                sorter: true,
                render: (text, record) => `${text} - ${record.mEmployeeName}`,
            }, {
                title: this.getText(11834),
                width: '10%',
                render: (text, record) => {

                    return (
                        <span>
                            {(record.mTypeID == '4' || record.mTypeID == '16') ?
                                <Tooltip title={this.getText(11838)}>
                                    <Icon style={{ fontSize: 16 }} className={"clickable margin-4"} type={"edit"} onClick={() => {
                                        //this.props.dataActions.genericDataStartEditing(this.id, record.key, record.index);
                                        this.props.uiActions.showModal(TableIDs.modalEditPurchaseDocument,
                                            { ...record, mDocType: record["mTypeID"] });
                                    }} />
                                </Tooltip>
                                : ""}
                            {/* <Popconfirm title={this.getText(11835)}
                                    onConfirm={() => {
                                        console.log("record", record);
                                        fixCurrentPage.bind(this)();
                                        this.props.dataActions.genericDataDeleteRow(
                                            this.id,
                                            record['mName'],
                                            this.props.user.companyCode,
                                            this.props.user.token,
                                            this.api.delete,
                                            this.api.get);
                                    }}
                                    okText={this.getText(11836)} cancelText={this.getText(11837)}>
                                    <Icon style={{ fontSize: 16, display: 'none' }} className={"clickable margin-4"} type={"delete"} />
                                </Popconfirm> */}
                            {this.isHandledBtn(record, 16)}
                            <Tooltip title={this.getText(21805)}>
                                <Icon
                                    style={{ fontSize: 16 }}
                                    className={"clickable margin-4"}
                                    type={"column-height"}
                                    onClick={() => { this.apiSumAndDiscount(record, (data) => { this.setState({ modalSumAndDiscountDoc: { ...data, ...record } }) }) }} />
                            </Tooltip>
                            <ReportShowButton
                                {...this.props}
                                iconButton
                                validSubmit
                                params={{
                                    DocumentNumber: record['mNumber'],
                                    DocumentTypeID: record['mTypeID'],
                                    DocumentPOSID: record['mPOSID'],
                                    userID: this.props.user.userId,
                                    userName: encodeURIComponent(this.props.user.displayName),
                                    docIsWithSigns: 0,
                                    reportName: "reports/DocumentCopy.pdf"
                                }} />
                            <Tooltip title={this.getText(21834)}>
                                <Icon style={{ fontSize: 16 }} className={"clickable margin-4"} type={"apartment"} onClick={() => {
                                    this.setState({ modalConcatDocs: record })
                                }} />
                            </Tooltip>
                            <Tooltip title={this.getText(21845)}>
                                <Icon style={{ fontSize: 16 }} className={"clickable margin-4"} type={"global"} onClick={() => {
                                    this.apiLines(record)
                                    this.apiSumAndDiscount(record, (sumAndDiscount) => {
                                        this.setState({ modalSummary: { ...record, sumAndDiscount } })
                                    })
                                }} />
                            </Tooltip>
                        </span >);
                }

            }
        ];

        let actionButtons = [
            {
                buttonType: "filter",
                buttonFunction: () => { this.props.uiActions.showModal(TableIDs.modalSearchPuchaseTable) }
            },
            {
                buttonType: 'refresh',
                buttonFunction: this.refreshData
            }
        ];

        // let radioReportType = (<Radio.Group style={{ direction: 'rtl' }} value={this.state.reportName} onChange={e => { this.setState({ reportName: e.target.value }) }}>
        //     <Radio value={"reports/PurchaseReport.pdf"}>{this.getText(16238)}</Radio>
        //     <Radio value={"reports/PurchaseReportCentralSupplier.pdf"}>{this.getText(16239)}</Radio>
        //     <Radio value={"reports/PurchaseReportCentralDoc.pdf"}>{this.getText(16240)}</Radio>
        //     <Button type={'primary'} onClick={this.generateReport}>{this.getText(16241)}</Button>
        // </Radio.Group>)

        let genericActionButtons = [
            <Tooltip title={this.getText(16236)}>
                {/* <Popover content={radioReportType} title={this.getText(16237)} trigger="click"> */}
                <Button key={"report-print"} className={"btn"} style={{ marginTop: "5px", marginLeft: "5px" }} onClick={() => {
                    this.setState({ modalReport: true, reportRequest: { ...this.state.reportRequest, ...this.props.data[this.id].filters } })
                }}>
                    <Icon style={{ fontSize: 16 }} type={"printer"} theme="outlined" />
                </Button>
                {/* </Popover> */}
            </Tooltip >
        ]

        const { _FromDate, _ToDate, _PosList, _StorageList, _SupplierList, _itemTagList, _isAsc, _sort_by, _words, _typeID, reportName } = this.state.reportRequest;

        let params = {
            _FromDate,
            _ToDate,
            _PosList,
            _StorageList,
            _SupplierList,
            _itemTagList,
            _isAsc,
            _sort_by,
            _words: encodeURIComponent(_words),
            _typeID,
            reportName,
            REPORT_LOCALE: this.getText(101),
        }

        return (
            <div style={divStyle}>
                <PageToolbar
                    title={this.getText(11824)}
                    actionButtons={actionButtons}
                    genericActionButtons={genericActionButtons}
                    showsearch={(val) => {
                        this.props.dataActions.genericDataSetFilter(
                            this.id, this.props.user.companyCode, this.props.user.token,
                            {
                                // ...request,
                                _words: val
                                    .trim().replace(/\s\s+/g, ' ').replace(/\'/g, "\\\'"),
                                page: 1,
                                _page_num: 1,
                            }, this.api.get)
                    }}
                    ui={this.props.ui}
                    uiActions={this.props.uiActions} />
                <ResponsiveTable
                    tableOnly={true}
                    percentageToMobile={[false, 20, 40, false, false, false, false, 40]}
                    ui={this.props.ui}
                    idTable={this.props.data[this.id]}
                    dataSource={dataSource}
                    columns={columns}
                    onChange={this.handleTableChange}
                />

                <ModalPurchaseAdvanceSearch
                    id={TableIDs.modalSearchPuchaseTable}
                    user={this.props.user}
                    ActionQueue={this.props.ActionQueue}
                    uiActions={this.props.uiActions} ui={this.props.ui}
                    dataActions={this.props.dataActions} data={this.props.data}
                    toggle={this.props.ui.modalStack.includes(TableIDs.modalSearchPuchaseTable)}
                />

                <ModalEditPurchaseDocument
                    id={TableIDs.modalEditPurchaseDocument}
                    user={this.props.user}
                    ActionQueue={this.props.ActionQueue}
                    uiActions={this.props.uiActions} ui={this.props.ui}
                    dataActions={this.props.dataActions} data={this.props.data}
                    toggle={this.props.ui.modalStack.includes(TableIDs.modalEditPurchaseDocument)}
                />

                <GenericModal
                    visible={this.state.modalReport}
                    onCancel={() => { this.setState({ modalReport: false }) }}
                    title={this.getText(17912)}
                    width={1200}>
                    <Row>
                        <Col span={window.innerWidth > 600 ? 12 : 24}>
                            <Form.Item label={this.getText(17913)}>{this.getModalReportField("_FromDate")}</Form.Item>
                            <Form.Item label={this.getText(17914)}>{this.getModalReportField("_ToDate")}</Form.Item>
                            <Form.Item label={this.getText(17915)}>{this.getModalReportField("_PosList")}</Form.Item>
                            <Form.Item label={this.getText(22718)}>{this.getModalReportField("_StorageList")}</Form.Item>
                            <Form.Item label={this.getText(17916)}>{this.getModalReportField("_SupplierList")}</Form.Item>
                            <Form.Item label={this.getText(19026)}>{this.getModalReportField("_itemTagList")}</Form.Item>
                        </Col>
                        <Col span={window.innerWidth > 600 ? 12 : 24} style={{ paddingRight: 20 }}>
                            <Form.Item label={this.getText(17917)}>{this.getModalReportField("_words")}</Form.Item>
                            <Form.Item label={this.getText(17918)}>{this.getModalReportField("_typeID")}</Form.Item>
                            <Form.Item label={this.getText(17919)}>{this.getModalReportField("reportName")}</Form.Item>
                            <ReportTypeButton
                                {...this.props}
                                params={params}
                                posField={'_posList'}
                                datesToFavorites={[
                                    { field: '_FromDate', label: this.getText(17913) },
                                    { field: '_ToDate', label: this.getText(17914) },
                                ]}
                                favoriteSave
                            />
                        </Col>
                    </Row>

                </GenericModal>
                <GenericModal
                    visible={this.state.modalSumAndDiscountDoc != null}
                    onCancel={() => { this.setState({ modalSumAndDiscountDoc: null }) }}
                    width={600}
                    title={<h2 style={{ textAlign: "center", marginTop: -15, color: "white" }}>
                        {this.state.modalSumAndDiscountDoc?.mTypeName} {this.state.modalSumAndDiscountDoc?.mNumber}
                    </h2>}
                    footer={[<Button onClick={() => { this.setState({ modalSumAndDiscountDoc: null }) }}>{this.getText(21806)}</Button>]}
                >
                    <h2 style={{ textAlign: "center" }}>{this.state.modalSumAndDiscountDoc?.mSupplierName}</h2>
                    <div style={{ fontSize: 18, lineHeight: 2 }}>
                        <Row>
                            <Col span={8}><b>{this.getText(21807)}:</b></Col>
                            <Col span={16}>{this.state.modalSumAndDiscountDoc?.dSum} ₪ {this.getText(21858)} {this.getText(21866)} {this.state.modalSumAndDiscountDoc?.dDiscountItem}</Col>
                        </Row>
                        <Row>
                            <Col span={8}><b>{this.state.modalSumAndDiscountDoc?.dDiscountItem}:</b></Col>
                            <Col span={16}>{this.state.modalSumAndDiscountDoc?.dDiscount} ₪ {this.getText(21858)} <br />{this.getText(21809)} {this.state.modalSumAndDiscountDoc?.dPercent}</Col>
                        </Row>
                        <Row>
                            <Col span={8}><b>{this.getText(21860)}:</b></Col>
                            <Col span={16}>{this.state.modalSumAndDiscountDoc?.dQty}</Col>
                        </Row>
                    </div>
                </GenericModal>
                <GenericModal
                    visible={this.state.modalConcatDocs != null}
                    onCancel={() => { this.setState({ modalConcatDocs: null }) }}
                    width={800}
                    title={this.getText(21834)}
                    actionButtons={[
                        {
                            buttonType: 'refresh',
                            buttonFunction: this.refreshConcatDocsData
                        }, {
                            buttonType: 'add',
                            buttonFunction: () => { this.setState({ modalAddConcatDocs: true }) }
                        }
                    ]}
                >
                    {this.state.modalConcatDocs ? this.getConcatTable(this.state.modalConcatDocs, { pageSize: 10 }) : ""}
                </GenericModal>
                <GenericModal
                    visible={this.state.modalEditConcatRemark != null}
                    onCancel={() => { this.setState({ modalEditConcatRemark: null }) }}
                    width={800}
                    title={this.getText(21883)}
                    footer={[
                        <Button onClick={() => {
                            this.setState({ modalEditConcatRemark: null })
                        }}>{this.getText(21881)}</Button>,
                        <Button onClick={() => {
                            const { cID, cRemark } = this.state.modalEditConcatRemark
                            this.sendAPI(this.api.edit_concat, { cID, cRemark }, () => {
                                this.setState({ modalEditConcatRemark: null }, this.refreshConcatDocsData)
                            })
                        }}>{this.getText(21882)}</Button>,
                    ]}
                >
                    <Input.TextArea
                        rows={10}
                        value={this.state.modalEditConcatRemark?.cRemark}
                        onChange={e => { this.setState({ modalEditConcatRemark: { ...this.state.modalEditConcatRemark, cRemark: e.target.value } }) }}
                    />
                </GenericModal>
                <CopyDocumentReport
                    {...this.props}
                    isModalFromDashboard
                    visible={this.state.modalAddConcatDocs}
                    onCancel={() => { this.setState({ modalAddConcatDocs: false }) }}
                    suppId={this.state.modalConcatDocs?.mSupplierID}
                    onCheckDoc={this.addConcatDoc}
                />
                <GenericModal
                    visible={this.state.modalSummary != null}
                    onCancel={() => { this.setState({ modalSummary: null }) }}
                    width={1200}
                    title={<h2 style={{ textAlign: "center", marginTop: -15, color: "white" }}>
                        {this.state.modalSummary?.mTypeName} {this.state.modalSummary?.mNumber} {this.state.modalSummary?.mSupplierName}
                    </h2>}
                    footer={[<Button onClick={() => { this.setState({ modalSummary: null }) }}>{this.getText(21864)}</Button>]}
                >
                    <div>
                        <Row style={{ fontSize: 18 }}>
                            <Col span={3}>{this.getText(21846)}</Col>
                            <Col span={5}><b>{moment(this.state.modalSummary?.mTimestamp).format("DD/MM/YYYY")}</b></Col>
                            <Col span={3}>{this.getText(21847)}</Col>
                            <Col span={5}><b>{this.state.modalSummary?.mPOSID} - {this.state.modalSummary?.mPOSName}</b></Col>
                            <Col span={3}>{this.getText(21848)}</Col>
                            <Col span={5}><b>{this.state.modalSummary?.mEmployeeName}</b></Col>
                            <Col span={3}>{this.getText(21849)}</Col>
                            <Col span={5}><b>{this.state.modalSummary?.mDocumentRef2}</b></Col>
                            <Col span={3}>{this.getText(21850)}</Col>
                            <Col span={5}><b>{this.state.modalSummary?.mStorageID} - {this.state.modalSummary?.mStorageName}</b></Col>
                            <Col span={3}>{this.getText(21851)}</Col>
                            <Col span={5}><b>{this.getText(this.state.modalSummary?.mIsHandled == '1' ? 21852 : this.state.modalSummary?.mIsHandled == '0' ? 21853 : 21942)}</b></Col>
                            <br />
                            <br />
                            <br />
                            <Col span={8}>
                                <Row>
                                    <Col span={12}>{this.getText(21854)}</Col>
                                    <Col span={12}><b>{formatter.format(this.state.modalSummary?.mTotalNoTax)}</b></Col>
                                    <Col span={12}>{this.getText(21855)}</Col>
                                    <Col span={12}><b>{formatter.format(this.state.modalSummary?.mTotalTax)}</b></Col>
                                    <Col span={12}>{this.getText(21856)}</Col>
                                    <Col span={12}><b>{formatter.format(this.state.modalSummary?.mTotalWithTax)}</b></Col>
                                </Row>
                            </Col>

                            <Col span={10}>
                                <Row>
                                    <Col span={12}>{this.getText(21857)}</Col>
                                    <Col span={12}><b>{formatter.format(this.state.modalSummary?.sumAndDiscount?.dDiscount)}</b> {this.getText(21858)}</Col>
                                    <Col span={12}>{this.getText(21859)}</Col>
                                    <Col span={12}><b>{this.state.modalSummary?.sumAndDiscount?.dPercent}</b></Col>
                                    <Col span={12}>{this.getText(21861)}</Col>
                                    <Col span={12}><b>{this.state.modalSummary?.sumAndDiscount?.dQty}</b></Col>
                                </Row>
                            </Col>

                            <Col span={6}>
                                {this.state.modalSummary ?
                                    this.isHandledBtn(this.state.modalSummary, 150, () => {
                                        this.setState({
                                            modalSummary: {
                                                ...this.state.modalSummary,
                                                mIsHandled: this.state.modalSummary.mIsHandled == '1' ? '' : this.state.modalSummary.mIsHandled == '0' ? '1' : '0'
                                            }
                                        })
                                    })
                                    : ""}
                            </Col>

                        </Row>
                        <br />
                        <h2>{this.getText(21862)}</h2>
                        <ResponsiveTable
                            tableOnly
                            dataSource={this.props.data[this.lines_id].data.map((x, index) => {
                                const [
                                    mDocumentNumber, mDocumentTypeID, mPOSID, mNumber,
                                    mItemCode, mItemBarcode, mDescription, mUnitPriceNoTax, mQuantity, mTotalSumNoTax,
                                    mCost, mActualQuantity, mItemIsMatrix, mColorUserCode, mColorDesc, mSizeCode, mSizeDesc, mDocBonusCalcData,
                                    mSuppBonusCalcData, mUpdateLine, mSupplier
                                ] = x.split("\f");
                                return {
                                    key: mNumber, index,
                                    mDocumentNumber, mDocumentTypeID, mPOSID, mNumber,
                                    mItemCode, mItemBarcode, mDescription, mUnitPriceNoTax, mQuantity, mTotalSumNoTax,
                                    mCost, mActualQuantity, mItemIsMatrix, mColorUserCode, mColorDesc, mSizeCode, mSizeDesc, mDocBonusCalcData,
                                    mSuppBonusCalcData, mUpdateLine, mSupplier
                                }
                            })}
                            pagination={false}
                            columns={[
                                { title: this.getText(11840), dataIndex: "mNumber", key: "mNumber", width: '6%', render: t => t },
                                { title: this.getText(11841), dataIndex: "mItemCode", key: "mItemCode", width: '18%', render: t => t },
                                { title: this.getText(11842), dataIndex: "mItemBarcode", key: "mItemBarcode", width: '18%', render: t => t },
                                { title: this.getText(11843), dataIndex: "mDescription", key: "mDescription", width: '18%', render: t => t },
                                { title: this.getText(11844), dataIndex: "mQuantity", key: "mQuantity", width: '10%', render: t => (<div style={{ textAlign: "right" }}>{parseFloat(t) ? parseFloat(t) : 0}</div>) },
                                {
                                    title: this.getText(11845), dataIndex: "mActualQuantity", key: "mActualQuantity", width: '10%',
                                    render: (text, record) => {
                                        const _color = (record['mActualQuantity'] - record['mQuantity'] != 0) ? 'red' : 'unset';
                                        return <div style={{ color: _color, textAlign: "right" }}>{parseFloat(text) ? parseFloat(text) : ""}</div>;
                                    }
                                }, {
                                    title: this.getText(11846), dataIndex: "mUnitPriceNoTax", key: "mUnitPriceNoTax", width: '10%',
                                    render: (text, record) => (<div key={"mUnitPriceNoTax-" + record.mDocumentNumber} style={{
                                        color: parseFloat(text) < parseFloat(record.mCost) ? 'green' : parseFloat(text) > parseFloat(record.mCost) ? 'red' : 'auto',
                                        textAlign: "right"
                                    }}>{text}</div>)
                                },
                                { title: this.getText(11847), dataIndex: "mCost", key: "mCost", width: '10%', render: t => (<div style={{ textAlign: "right" }}>{t}</div>) }
                            ]}
                        />
                        <br />
                        <h2>{this.getText(21863)}</h2>
                        {this.state.modalSummary ? this.getConcatTable(this.state.modalSummary, false) : ""}
                    </div>
                </GenericModal>
            </div>
        );
    }
}

export default PurchaseDocumentsTable;
